import {
  Card,
  Checkbox,
  ChoiceList,
  Form,
  FormLayout,
  List,
  Page,
  Button,
  TextContainer,
  TextField,
} from "@shopify/polaris";
import React, { Component } from "react";
import DateOfBirth from "../components/DateOfBirth";

export default class CovidForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gender: ["female"],
      first_name: "",
      first_name_error: false,
      last_name_error: false,
      last_name: "",
      email: "",
      email_error: false,
      vaccineDose: ["first"],
      consentCheck: false,
      street_address: "",
      street_address_error: false,
      city: "",
      health_card: "",
      health_card_error: false,
      province: "",
      postal_code: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.onVaccineDoseSelect = this.onVaccineDoseSelect.bind(this);
    this.onGenderSelect = this.onGenderSelect.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.submit = this.submit.bind(this);
  }
  onGenderSelect(e) {
    this.setState({ gender: e });
  }
  onVaccineDoseSelect(e) {
    this.setState({ vaccineDose: e });
  }
  handleChange(e, key) {
    if (key == "first_name") {
      this.setState({ first_name: e });
    } else if (key === "last_name") {
      this.setState({ last_name: e });
    } else if (key === "consentCheck") {
      this.setState({ consentCheck: e });
    } else if (key === "health_card") {
      this.setState({ health_card: e });
    } else if (key === "email") {
      this.setState({ email: e });
    } else if (key === "street_address") {
      this.setState({ street_address: e });
    } else if (key === "city") {
      this.setState({ city: e });
    } else if (key === "province") {
      this.setState({ province: e });
    } else if (key === "postal_code") {
      this.setState({ postal_code: e });
    }
  }
  validateForm() {
    if (this.state.first_name.length < 2) {
      this.setState({ first_name_error: true });
    }
    if (this.state.last_name.length < 2) {
      this.setState({ last_name_error: true });
    }
    if (this.state.street_address.length < 4) {
      this.setState({ street_address_error: true });
    }
    if (this.state.health_card.length < 8) {
      this.setState({ health_card_error: true });
    }
    if(this.state.email.length< 4){
      this.setState({email_error:true});
    }
  }
  submit() {
    this.validateForm();
  }
  render() {
    const {
      gender,
      first_name,
      first_name_error,
      last_name_error,
      email_error,
      last_name,
      email,
      health_card_error,
      street_address,
      street_address_error,
      postal_code,
      city,
      province,
      vaccineDose,
      consentCheck,
      health_card,
    } = this.state;
    console.log(this.state);
    const text = require("../en.json");

    return (
      <Page>
        <Form onSubmit={this.submit}>
          <FormLayout>
            <Card>
              <Card.Section>
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      error={first_name_error}
                      value={first_name}
                      onChange={(e) => this.handleChange(e, "first_name")}
                      label="First Name"
                    />
                    <TextField
                      error={last_name_error}
                      value={last_name}
                      onChange={(e) => this.handleChange(e, "last_name")}
                      label="Last Name"
                    />
                  </FormLayout.Group>
                  <TextField
                    label="Email"
                    type="email"
                    value={email}
                    error={email_error}
                    onChange={(e) => this.handleChange(e, "email")}
                  />
                  <TextField
                    onChange={(e) => this.handleChange(e, "health_card")}
                    value={health_card}
                    error={health_card_error}
                    label="health card number"
                  />
                  <ChoiceList
                    title="Gender"
                    choices={[
                      { label: "Female", value: "female" },
                      { label: "Male", value: "male" },
                      { label: "Preffer not to say", value: "other" },
                    ]}
                    selected={gender}
                    onChange={this.onGenderSelect}
                  />
                  <DateOfBirth title={"Date of birth"} />
                </FormLayout>
              </Card.Section>
              <Card.Section title="Address">
                <FormLayout>
                  <TextField
                    value={street_address}
                    onChange={(e) => this.handleChange(e, "street_address")}
                    label="Street Address"
                    error={street_address_error}
                  />
                  <FormLayout.Group condensed>
                    <TextField
                      value={city}
                      onChange={(e) => this.handleChange(e, "city")}
                      label="City"
                    />
                    <TextField
                      value={province}
                      onChange={(e) => this.handleChange(e, "province")}
                      label="Province"
                    />
                    <TextField
                      value={postal_code}
                      onChange={(e) => this.handleChange(e, "postal_code")}
                      label="Postal Code"
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
            </Card>
            <Card title="Vaccination Dose">
              <Card.Section>
                <FormLayout>
                  <ChoiceList
                    onChange={this.onVaccineDoseSelect}
                    selected={vaccineDose}
                    title={text.vaccineDose.title}
                    choices={text.vaccineDose.options}
                  />
                </FormLayout>
              </Card.Section>
              {vaccineDose[0] === "second" ? (
                <Card.Section>
                  <FormLayout>
                    <DateOfBirth title={"Date of the first dose"} />
                    <TextField label="Name of vaccine administered" />
                  </FormLayout>
                </Card.Section>
              ) : null}
            </Card>
            <Card title="Consent to Receive the Vaccine">
              <Card.Section>
                <FormLayout>
                  <TextContainer spacing="tight">
                    <p>{text.consent.introText}</p>
                  </TextContainer>
                  <List type="bullet">
                    <List.Item>{text.consent.listContent[0]}</List.Item>
                  </List>
                  <Checkbox
                    checked={consentCheck}
                    label={text.consent.consentCheckBox}
                    onChange={(e) => this.handleChange(e, "consentCheck")}
                  />
                  <List type="bullet">
                    <List.Item>{text.consent.listContent[1]}</List.Item>
                    <List.Item>{text.consent.listContent[2]}</List.Item>
                  </List>
                </FormLayout>
              </Card.Section>
            </Card>
            <div style={{ margin: "auto", textAlign: "center" }}>
              <Button submit primary>
                Submit
              </Button>
            </div>
          </FormLayout>
        </Form>
      </Page>
    );
  }
}
